// userService.js
import { get, post, patch } from './common';



export const getExpertChatList = (filterData) => {
    return get('chat/get-expert-chat-list', filterData);
};

export const getChatMessages = (id, paginationData) => {
    return get('chat/get-messages/' + id, paginationData);
};

export const getChatFiles = (id, paginationData) => {
    return get('chat/get-chat-files/' + id, paginationData);
};


export const getConversationDetail = (id) => {
    console.log("vissssss")
    return get('chat/get-conversation-detail/' + id);
};


export const sendMessage = (messageData) => {
    return post('chat/send-message', messageData, { "content-type": "multipart/form-data" });
};

export const checkExpiredConversation = (id) => {
    return post('chat/chat-action/' + id);
};

export const messageRead = (id, messageId) => {
    return post('chat/chat-read/' + id, messageId)
}

